import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useCookies } from "react-cookie";
import { setWithExpiry, getWithExpiry } from '../../common';
import CourseLesson from "./CourseLesson";
import CourseTopic from "./CourseTopic";
import configVars from "../../config";

const CoursePage = (props) => {

    const { lesson, topic } = useParams();
    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [courseImage, setCourseImage] = useState("");
    const [lessonContent, setLessonContent] = useState("");
    const [topics, setTopics] = useState([]);
    const [courseData, setCourseData] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        const savedGuides = getWithExpiry( `sy_partner_${props?.courseid}_guides` );

        if ( savedGuides ) {

            let lessonData;

            if ( lesson ) {

                lessonData = Object.keys(savedGuides).filter(l => savedGuides[l].name === lesson).map(l => savedGuides[l]);

            } else {

                const firstLesson = savedGuides[Object.keys(savedGuides)[0]];

                lessonData = Object.keys(savedGuides).filter((l) => savedGuides[l].name === firstLesson.name).map((l) => savedGuides[l]);

            }
            

            if (!lessonData[0]) return;

            setCourseImage(lessonData[0].course_image);
            setLessonContent(lessonData[0].content);
            setTopics(lessonData[0].topics);
            setCourseData(savedGuides);
        } else {

            (async () => {

                setLoading( true );

                // let userRequestData = new FormData();
                // userRequestData.append( 'token', cookies.sustainyou_user_jwt );
    
                const fetchUrl = `${configVars.lmsApiUrl}sustainchangelms/v1/getcoursenav/?courseid=${props?.courseid}`;
    
                try{
    
                    const response = await fetch(
                        fetchUrl,
                        {
                        method: "GET",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                        }
                    );
                    
                    const courseResponse = await response.json();
	
                    if ( courseResponse && courseResponse.data ) {
        
                        const responseData = courseResponse.data;
        
                        setWithExpiry( `sy_partner_${props?.courseid}_guides`, responseData );
                        const firstLesson = responseData[Object.keys(responseData)[0]];

                        const lessonData = Object.keys(responseData)
                            .filter((l) => responseData[l].name === firstLesson.name)
                            .map((l) => responseData[l]);

                        if (lessonData[0]) {
                            setCourseImage(lessonData[0].course_image);
                            setLessonContent(lessonData[0].content);
                            setTopics(lessonData[0].topics);
                            setCourseData( courseResponse.data );
                        }
                    }
    
                } catch( error ) {
                    console.log( error );
                    return error;
                }

                setLoading( false );
    
            })()

        }


    }, [cookies.sustainyou_user_jwt, lesson, props.courseid]);

    return (
        <div className="col">

            { loading &&
                <div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status" >
                    <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            }

            { ! topic &&
                <CourseLesson image={courseImage} content={lessonContent} topics={topics} allData={courseData} courseID={props?.courseid} slug={props?.slug}  />
            }
            { (lesson && topic) &&
                <CourseTopic allData={courseData} courseID={props?.courseid} slug={props?.slug}  />
            }
        </div>
    )
}

export default CoursePage;